export default "__VITE_ASSET__BzvYvhbX__"